export enum SettingsComposerFeaturesEnum {
  EMOJI = 'EMOJI',
  MESSAGE_TEMPLATES = 'MESSAGE_TEMPLATES',
  CSAT_SURVEY = 'CSAT_SURVEY',
  ATTACHMENTS = 'ATTACHMENTS',
}
